module.exports = __webpack_public_path__ + "img/ic_qrcode_ins.16003cd.png";